import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _omit from 'lodash/omit'
import { Map, List } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { compose } from 'recompose'
import { get as getConfig } from '../../config/index'
import Filter from '../Filter/index'
import { isAnonymousHome, isGetStarted } from '../../services/url/index'
import { connect as connectStaticText } from '../StaticText/connect'
import connectRouter from '../Router/connect'
import { getBoundActions } from '../../actions/index'
import { historyRedirect } from '../../services/navigation/index'
import {
  NAVIGATION_EVENT_LABELS,
  PRIMARY_LANGUAGE_CHANGED_GA4_EVENT,
} from '../../services/event-tracking/index'
import { getLabel as getLanguageLabel } from '../../services/lang/index'
import { getPrimary } from '../../services/languages/index'

const { features } = getConfig()

function createDefaultOption (langs, languagePreference) {
  return langs.find((v) => v.get('value') === languagePreference)
}

class LanguageSelectGlobe extends React.Component {
  //
  onChange = (target) => {
    const { props } = this
    const {
      auth,
      history,
      location,
      setFeatureTrackingDataPersistent,
      setEventDefault,
      setUserDataLanguage,
    } = props

    const { value: language } = target
    setFeatureTrackingDataPersistent({
      data: Map({ userLanguages: List([language]) }),
      auth,
    })

    // GA4 events
    const eventData = PRIMARY_LANGUAGE_CHANGED_GA4_EVENT
      .mergeDeep({
        changed_to: language,
        ui_element: 'Nav Globe',
      })
    setEventDefault(eventData)

    // This sets assumes that there is no secondary language support
    if (!auth.get('jwt')) {
      // For anonymous users just change the URL
      historyRedirect({
        url: location.pathname,
        query: _omit(location.query, ['language']),
        language,
        history,
        auth,
      })
    } else {
      // Authenticated: update user language in session and stay in the SPA.
      // Flags refresh via client identify.
      setUserDataLanguage(List([language]))
    }
  }

  render () {
    if (features.languageSelectGlobeAnonymous) {
      const { props } = this
      const {
        auth,
        languages,
        userLanguage,
        location,
        setNavigationClickEvent,
        darkMode,
      } = props
      const classes = ['language-select-globe']
      const languagePreference = userLanguage.get(0, 'en')
      const langs = languages.get('data', List()).filter((lang) => ((features.languageSelectFr && lang.get('name') === 'Français')
          || (features.languageSelectDe && lang.get('name') === 'Deutsch')
          || ['Français', 'Deutsch'].indexOf(lang.get('name')) < 0))
      if (isAnonymousHome(location.pathname, auth.get('jwt'))) {
        classes.push('language-select-globe--homepage')
      }
      if (isGetStarted(location.pathname)) {
        classes.push('language-select-globe--get-started')
      }
      if (darkMode) {
        classes.push('language-select-globe--dark-mode')
      }

      return (
        <div className={classes.join(' ')}>
          <Filter
            label={getLanguageLabel(getPrimary(userLanguage))}
            className={['language-select-globe__control']}
            labelClassName={['language-select-globe__label']}
            defaultOption={createDefaultOption(langs, languagePreference)}
            onChange={this.onChange}
            onFocus={() => {
              setNavigationClickEvent(NAVIGATION_EVENT_LABELS.LANGUAGE_GLOBE, 'nav globe')
            }}
            options={langs}
          />
        </div>
      )
    }
    return null
  }
}

LanguageSelectGlobe.propTypes = {
  languages: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
  setUserDataLanguage: PropTypes.func.isRequired,
  getLanguagesData: PropTypes.func.isRequired,
  setNavigationClickEvent: PropTypes.func,
  setEventDefault: PropTypes.func,
  darkMode: PropTypes.bool,
}

// Unconnected class exported for unit tests (the default export is the connected
// component). Aliased so it doesn't collide with the default import name.
export { LanguageSelectGlobe as LanguageSelectGlobeBase }

export default compose(
  connectRouter(),
  connectRedux(
    (state) => ({
      auth: state.auth,
      languages: state.languages,
      userLanguage: state.user.getIn(['data', 'language']),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent:
          actions.featureTracking.setFeatureTrackingDataPersistent,
        getLanguagesData: actions.languages.getLanguagesData,
        setEventDefault: actions.eventTracking.setEventDefault,
        setUserDataLanguage: actions.user.setUserDataLanguage,
      }
    },
  ),
  connectStaticText({
    storeKey: 'languageSelect',
  }),
)(LanguageSelectGlobe)
